/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { GetUsersQueryResponse, GetUsers400 } from '../entities/GetUsers'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'

function getGetUsersUrl() {
  return `/users` as const
}

/**
 * @description Получение списка пользователей
 * @summary Получение списка пользователей
 * {@link /users}
 */
export async function getUsers(config: Partial<RequestConfig> & { client?: typeof client } = {}) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<GetUsersQueryResponse, ResponseErrorConfig<GetUsers400>, unknown>({
    method: 'GET',
    url: getGetUsersUrl().toString(),
    ...requestConfig,
  })
  return res.data
}